import { render, staticRenderFns } from "./loading-plans.vue?vue&type=template&id=667d6c62&"
import script from "./loading-plans.vue?vue&type=script&lang=js&"
export * from "./loading-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports